import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('login-auth-ignore/list', { params });
  },
  async add(params: any) {
    return axios.post('login-auth-ignore/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('login-auth-ignore/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('login-auth-ignore/detail', { params });
  },
  async delete(params: any) {
    return axios.post('login-auth-ignore/delete', qs.stringify(params));
  }
};
